import React from "react";
import { Link } from "react-router-dom";
import { ShoppingCart, Dumbbell } from "lucide-react";
import { useCart } from "@/context/CartContext";

const Navbar: React.FC = () => {
  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  return (
    <header className="bg-emerald-700 text-white shadow-md">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <Dumbbell className="h-8 w-8" />
            <span className="text-xl font-bold">Jog N Gym</span>
          </Link>
          
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="hover:text-emerald-200 transition-colors">
              Home
            </Link>
            <Link to="/products" className="hover:text-emerald-200 transition-colors">
              Products
            </Link>
            <Link to="/about" className="hover:text-emerald-200 transition-colors">
              About
            </Link>
            <Link to="/contact" className="hover:text-emerald-200 transition-colors">
              Contact
            </Link>
          </nav>
          
          <Link to="/cart" className="relative">
            <ShoppingCart className="h-6 w-6 hover:text-emerald-200 transition-colors" />
            {cartCount > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
                {cartCount}
              </span>
            )}
          </Link>
        </div>
        
        {/* Mobile Navigation */}
        <nav className="md:hidden flex justify-between mt-4 border-t border-emerald-600 pt-4">
          <Link to="/" className="text-sm hover:text-emerald-200 transition-colors">
            Home
          </Link>
          <Link to="/products" className="text-sm hover:text-emerald-200 transition-colors">
            Products
          </Link>
          <Link to="/about" className="text-sm hover:text-emerald-200 transition-colors">
            About
          </Link>
          <Link to="/contact" className="text-sm hover:text-emerald-200 transition-colors">
            Contact
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;